export default "__VITE_ASSET__BCxCj9od__"